<template>
  <section-box class="mb-100">
    <notes-default :noteable="record"></notes-default>
  </section-box>
</template>

<script>
export default {
  name: "LeadNotes",
  computed: {
    record() {
      // If activeRecord is null then return necessary empty info
      return this.$store.state.activeRecord ? this.$store.state.activeRecord.record : {
        id: null,
        class_name: null,
        body: null,
      };
    },
  }
}
</script>
